import { render } from "./HeaderLogoView.vue?vue&type=template&id=157b64dc&scoped=true"
const script = {}

import "./HeaderLogoView.vue?vue&type=style&index=0&id=157b64dc&scoped=true&lang=sass"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-157b64dc"]])

export default __exports__